<template>
  <div class="full-height">
    <foobar-header></foobar-header>
    <intro></intro>
    <section-intro :title="$t('message.title.main.foobar_editor')"></section-intro>
    <foobar-edit :foobar-id="$route.params.id"></foobar-edit>
    <foobar-footer></foobar-footer>
  </div>
</template>

<script>
  import Intro from '@/components/partials/IntroLarge'
  import FoobarHeader from '@/components/partials/Header'
  import FoobarFooter from '@/components/partials/Footer'
  import FoobarEdit from '@/components/foobar/FoobarEdit'
  import SectionIntro from '@/components/partials/SectionIntroZeroOne'

  export default {
    components: {
      Intro,
      FoobarFooter,
      FoobarHeader,
      FoobarEdit,
      SectionIntro
    }
  }
</script>



// WEBPACK FOOTER //
// FoobarEditor.vue?bc8f3310